import React from 'react'
import '../App.css'
import Bodyactivate from './bodyactivate'
export class Bodyappactivatebody extends React.Component {
    constructor(props){
        super (props);
        this.state={
            mail:''
        };
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyactivate mailRegister={this.props.mailRegister}/>
                </div>
            </div>
        );
    }
}